import { GuardedType, IsInterface, UnionOf, isSingletonString } from "generic-type-guard";

const broadcastChannel = new BroadcastChannel("MODUL-F");

const isLogoutMessage = new IsInterface().withProperties({ type: isSingletonString("logout") }).get();
const isMessage = new UnionOf(isLogoutMessage).get();

type Message = GuardedType<typeof isMessage>;

export const channel = {
	subscribe(listener: (message: Message) => void): () => void {
		function wrapper(event: MessageEvent): void {
			if (isMessage(event.data)) {
				listener(event.data);
			}
		}

		broadcastChannel.addEventListener("message", wrapper);
		return () => broadcastChannel.removeEventListener("message", wrapper);
	},
	post(message: Message): void {
		broadcastChannel.postMessage(message);
	}
} as const;
